export default __webpack_public_path__ + "locales/sr-Latn-RS/Settings.json?hash=00338853163dc443242ba09d86f45836";